<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Pelunasan Piutang Declaring
        <v-spacer />
        <v-text-field
          v-model="filter"
          label="Cari No. SPK / Customer"
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          hide-details
          style="max-width: 320px"
        />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :loading="loading.fetch"
        :items-per-page="10"
        dense
      >
        <template v-slot:item.nilai_tagihan="{ item }">
          Rp {{ money(item.nilai_tagihan) }}
        </template>

        <template v-slot:item.laba_bersih="{ item }">
          Rp {{ money(item.laba_bersih) }}
        </template>

        <template v-slot:item.status_pelunasan="{ item }">
          <v-chip
            small
            :color="item.status_pelunasan === 'lunas' ? 'success' : 'warning'"
          >
            {{ item.status_pelunasan === "lunas" ? "Lunas" : "Belum Lunas" }}
          </v-chip>
        </template>

        <template v-slot:item.tanggal_lunas="{ item }">
          {{ item.tanggal_lunas || "-" }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="item.status_pelunasan !== 'lunas'"
            small
            color="success"
            @click="openDialog(item)"
          >
            <v-icon left small>mdi-cash-check</v-icon>
            Lunasi
          </v-btn>
          <v-btn
            v-else
            small
            color="error"
            :loading="loading.cancel && selected.id === item.id"
            @click="batalkanPelunasan(item)"
          >
            <v-icon left small>mdi-cash-remove</v-icon>
            Batal Lunas
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="460">
      <v-card>
        <v-card-title>Pelunasan {{ selected.no_spk }}</v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td>Customer</td>
                <td>{{ selected.nama_customer }}</td>
              </tr>
              <tr>
                <td>Nilai Pelunasan</td>
                <td>
                  <b>Rp {{ money(selected.nilai_tagihan) }}</b>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-text-field
            v-model="tanggalLunas"
            type="date"
            label="Tanggal Lunas *"
            class="mt-4"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Batal</v-btn>
          <v-btn
            color="success"
            :loading="loading.save"
            :disabled="!tanggalLunas"
            @click="lunasi"
          >
            Konfirmasi Pelunasan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

const today = () =>
  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 10);

export default {
  name: "PelunasanDeclaring",
  data: () => ({
    items: [],
    filter: "",
    dialog: false,
    selected: {},
    tanggalLunas: today(),
    loading: { fetch: false, save: false, cancel: false },
    headers: [
      { text: "No. SPK", value: "no_spk" },
      { text: "Customer", value: "nama_customer" },
      { text: "Pekerjaan", value: "pekerjaan" },
      { text: "Tanggal Mulai", value: "tanggal_mulai" },
      { text: "Nilai Tagihan", value: "nilai_tagihan" },
      { text: "Laba Bersih", value: "laba_bersih" },
      { text: "Status", value: "status_pelunasan" },
      { text: "Tanggal Lunas", value: "tanggal_lunas" },
      { text: "Aksi", value: "actions", sortable: false }
    ]
  }),
  computed: {
    filteredItems() {
      const keyword = String(this.filter || "")
        .toLowerCase()
        .trim();
      if (!keyword) return this.items;

      return this.items.filter(item =>
        `${item.no_spk} ${item.nama_customer}`.toLowerCase().includes(keyword)
      );
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    money(value) {
      return Number(value || 0).toLocaleString("id-ID");
    },
    async fetchData() {
      this.loading.fetch = true;
      try {
        const response = await axios.get("declaring");
        this.items = response.data;
      } catch (error) {
        alert(
          error.response?.data?.message || "Gagal memuat piutang Declaring"
        );
      } finally {
        this.loading.fetch = false;
      }
    },
    openDialog(item) {
      this.selected = item;
      this.tanggalLunas = today();
      this.dialog = true;
    },
    async lunasi() {
      this.loading.save = true;
      try {
        await axios.put(`declaring/${this.selected.id}/lunasi`, {
          tanggal_lunas: this.tanggalLunas
        });
        this.dialog = false;
        await this.fetchData();
      } catch (error) {
        alert(
          error.response?.data?.message || "Gagal melakukan pelunasan Declaring"
        );
      } finally {
        this.loading.save = false;
      }
    },
    async batalkanPelunasan(item) {
      if (!confirm(`Batalkan pelunasan SPK ${item.no_spk}?`)) return;

      this.selected = item;
      this.loading.cancel = true;
      try {
        await axios.put(`declaring/${item.id}/batalkan-pelunasan`);
        await this.fetchData();
      } catch (error) {
        alert(
          error.response?.data?.message ||
            "Gagal membatalkan pelunasan Declaring"
        );
      } finally {
        this.loading.cancel = false;
        this.selected = {};
      }
    }
  }
};
</script>
